import { action } from 'satcheljs';

export const loadActivityFeed = action('LOAD_ACTIVITY_FEED', () => ({}));
